/* NemoMatheo: consent-aware, signed first-party referral tracking. No Admin API credentials. */
(function () {
  'use strict';
  if (window.__nmMeinAdventReferral) return;
  window.__nmMeinAdventReferral = true;
  window.__nmMeinAdventReferralVersion = '20261016.2';
  var REF = '1d148bae';
  var NAME = 'Mein Adventskalender';
  var STORE_KEY = 'nm_mein_advent_referral_v1';
  var API = 'https://ship.njswgzkj.com/api/affiliate-referral/click';
  var HANDLES = ['schmuck-adventskalender-2026-forza-gentile', 'schmuck-adventskalender-2026-anima-in-fiore'];
  var originalFetch = window.fetch.bind(window);
  var ticket = null;
  var busy = false;
  var pending = null;
  var issuedForPage = false;
  var consentCleaned = false;
  var lastSynced = '';
  var observer;
  var params = new URLSearchParams(window.location.search);
  var entryRef = params.get('nm_ref') || params.get('ref');

  function cartUrl(path) {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + path;
  }
  function consentAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;
    if (typeof privacy.firstPartyMarketingAllowed === 'function') return privacy.firstPartyMarketingAllowed() === true;
    return typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true;
  }
  function valid(value) {
    return value && value.ref === REF && typeof value.ticket === 'string' && value.ticket.length < 900 &&
      typeof value.expiresAt === 'number' && value.expiresAt > Date.now();
  }
  function properties(existing) {
    return Object.assign({}, existing || {}, { _nm_ref: REF, _nm_affiliate_ticket: ticket.ticket });
  }
  function attributes() {
    return { nm_ref: REF, nm_affiliate_ticket: ticket.ticket, '推广来源': NAME, '来源网站': 'mein-adventskalender.de', '归因方式': '专属推广链接' };
  }
  function attachForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      ['_nm_ref', '_nm_affiliate_ticket'].forEach(function (name) {
        var input = form.querySelector('[data-nm-referral="' + name + '"]');
        if (!valid(ticket) || !consentAllowed()) { if (input) input.remove(); return; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden'; input.name = 'properties[' + name + ']';
          input.setAttribute('data-nm-referral', name); form.appendChild(input);
        }
        var value = name === '_nm_ref' ? REF : ticket.ticket;
        if (input.value !== value) input.value = value;
      });
    });
  }
  async function clearCart() {
    try {
      var response = await originalFetch(cartUrl('cart.js'), { credentials: 'same-origin' });
      if (!response.ok) return;
      var cart = await response.json();
      if (cart.attributes && cart.attributes.nm_ref === REF) {
        var remove = { nm_ref: '', nm_affiliate_ticket: '' };
        if (cart.attributes['推广来源'] === NAME) {
          remove['推广来源'] = ''; remove['来源网站'] = ''; remove['归因方式'] = '';
        }
        await originalFetch(cartUrl('cart/update.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: remove }) });
      }
      for (var item of cart.items || []) {
        if (!item.properties || item.properties._nm_ref !== REF) continue;
        var kept = Object.assign({}, item.properties);
        delete kept._nm_ref; delete kept._nm_affiliate_ticket;
        await originalFetch(cartUrl('cart/change.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, properties: kept }) });
      }
    } catch (_) { /* Marketing failures must not block shopping. */ }
  }
  async function forget(clear) {
    ticket = null; lastSynced = '';
    try { localStorage.removeItem(STORE_KEY); } catch (_) {}
    attachForms();
    if (clear) await clearCart();
  }
  async function syncCart() {
    if (!valid(ticket) || !consentAllowed() || lastSynced === ticket.ticket) return;
    var active = ticket.ticket;
    try {
      var response = await originalFetch(cartUrl('cart/update.js'), {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes() }),
      });
      if (response.ok && ticket && active === ticket.ticket && consentAllowed()) lastSynced = active;
      else if (response.ok && (!valid(ticket) || !consentAllowed())) await clearCart();
    } catch (_) {}
  }
  async function activate() {
    if (!consentAllowed()) {
      if (!consentCleaned || ticket || localStorageAvailable()) { consentCleaned = true; await forget(true); }
      return;
    }
    consentCleaned = false;
    if (busy) return;
    busy = true;
    try {
      if (entryRef && entryRef !== REF) { await forget(true); return; }
      var cached;
      try { cached = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (_) {}
      if (valid(cached)) ticket = cached;
      else if (cached) await forget(true);
      var match = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (!valid(ticket) && !issuedForPage && entryRef === REF && match && HANDLES.indexOf(match[1]) !== -1) {
        try {
          var response = await originalFetch(API, {
            method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ref: REF, product: match[1], consent: true }),
            signal: AbortSignal.timeout(8000),
          });
          if (response.ok) {
            var issued = await response.json();
            if (!consentAllowed()) { await forget(true); return; }
            if (valid(issued)) {
              ticket = issued;
              issuedForPage = true;
              try { localStorage.setItem(STORE_KEY, JSON.stringify(issued)); } catch (_) {}
            }
          }
        } catch (_) {}
      }
      attachForms();
      await syncCart();
    } finally { busy = false; }
  }
  function localStorageAvailable() {
    try { return !!localStorage.getItem(STORE_KEY); } catch (_) { return false; }
  }
  function activateTracked() {
    if (busy) {
      if (!consentAllowed()) return forget(true);
      return pending || Promise.resolve();
    }
    pending = activate();
    return pending;
  }
  async function waitForProof() {
    if (!consentAllowed()) return;
    // A visitor can press Buy immediately after granting consent. Give the
    // in-flight issuer a short chance, while keeping purchases fail-open.
    // A ticket may already be cached while the first cart/update request is
    // still establishing Shopify's cart cookie. Concurrent cart/add can create
    // another cart and lose its attributes; wait for that update as well.
    var work = busy && pending ? pending : (!valid(ticket) && entryRef === REF ? activateTracked() : null);
    if (work) await Promise.race([work, new Promise(function (resolve) { setTimeout(resolve, 2500); })]);
  }

  // Attach proof to AJAX cart additions as well as native/accelerated product
  // forms. Preserve all existing personalization, discounts and request headers.
  window.fetch = async function (input, init) {
    try {
      var url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
      var opts = init || {};
      if (url.origin === window.location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname) &&
        String(opts.method || (input && input.method) || 'GET').toUpperCase() === 'POST') {
        await waitForProof();
        if (!valid(ticket) || !consentAllowed()) return originalFetch(input, init);
        opts = Object.assign({}, opts);
        if (opts.body instanceof FormData) {
          var copy = new FormData(); opts.body.forEach(function (v, k) { copy.append(k, v); });
          copy.set('properties[_nm_ref]', REF); copy.set('properties[_nm_affiliate_ticket]', ticket.ticket); opts.body = copy;
        } else if (opts.body instanceof URLSearchParams) {
          var form = new URLSearchParams(opts.body);
          form.set('properties[_nm_ref]', REF); form.set('properties[_nm_affiliate_ticket]', ticket.ticket); opts.body = form;
        } else if (typeof opts.body === 'string') {
          var json = JSON.parse(opts.body);
          if (Array.isArray(json.items)) json.items = json.items.map(function (item) { return Object.assign({}, item, { properties: properties(item.properties) }); });
          else if (json.id) json.properties = properties(json.properties);
          opts.body = JSON.stringify(json);
        }
        return originalFetch(input, opts);
      }
    } catch (_) {}
    return originalFetch(input, init);
  };

  document.addEventListener('visitorConsentCollected', function () { activateTracked(); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      if (ticket && !valid(ticket)) forget(true);
      else activateTracked();
    }
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    attachForms();
    if (valid(ticket) || !consentAllowed() || entryRef !== REF || form.dataset.nmReferralResuming) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var submitter = event.submitter;
    waitForProof().finally(function () {
      attachForms(); form.dataset.nmReferralResuming = '1';
      try { form.requestSubmit(submitter || undefined); }
      finally { delete form.dataset.nmReferralResuming; }
    });
  }, true);
  function start() {
    observer = new MutationObserver(function () { attachForms(); });
    observer.observe(document.body, { childList: true, subtree: true });
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) activateTracked();
    else if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) activateTracked(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
